import DynamicSvgActions from "./DynamicSvgActions";

export default DynamicSvgActions;
